import { ItemModel } from '../models/ItemModel';
import { formatVideoTime } from './formatVideoTime';

export function formatVideoFileTime(file: ItemModel) {
    const timeMs = file.videoTimeSeconds ?? 0;
    return formatVideoTime(timeMs / 1000);
}
